const authorlist = [
    {
        name: "Kyle Lennon",
        institution: "Massachusetts Institute of Technology",
        url: "https://www.linkedin.com/in/kyle-r-lennon"
    },
    {
        name: "Katharina Fransen",
        institution: "Massachusetts Institute of Technology",
        url: "https://www.linkedin.com/in/katharina-fransen"
    },
    {
        name: "Alexander O'Brien",
        institution: "Massachusetts Institute of Technology",
        url: ""
    },
    {
        name: "Yumeng Cao",
        institution: "Massachusetts Institute of Technology",
        url: "http://yumeng.mit.edu/"
    },
    {
        name: "Matthew Beveridge",
        institution: "Massachusetts Institute of Technology",
        url: "https://mattbeveridge.com/"
    },
    {
        name: "Yamin Arefeen",
        institution: "Massachusetts Institute of Technology",
        url: "https://www.linkedin.com/in/yamin-arefeen-35481180"
    },
    {
        name: "Nikhil Singh",
        institution: "Massachusetts Institute of Technology",
        url: "https://web.media.mit.edu/~nsingh1/"
    },
    {
        name: "Iddo Drori",
        institution: "Massachusetts Institute of Technology",
        url: "https://www.mit.edu/~idrori/"
    }
];

export default authorlist;